var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"rastar-toast",class:_vm.active ? 'active' : '',attrs:{"id":"toast"}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }